// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"flag-icon-css-mg\" viewBox=\"0 0 640 480\"> <g fill-rule=\"evenodd\" stroke-width=\"1pt\"> <path fill=\"#ff3319\" d=\"M213.3 0H640v240H213.3z\"/> <path fill=\"#00cc28\" d=\"M213.3 240H640v240H213.3z\"/> <path fill=\"#fff\" d=\"M0 0h213.3v480H0z\"/> </g> </svg> ";
// Exports
module.exports = code;